var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class LiteTouch {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.deviceId = '01'; // Factory default ID for the display
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: `k${this.deviceId}gi000`,
                next: /k\d+ri00(\d)|Now Standby|Now On/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`k${this.deviceId}gi000`, /(Now Standby|Now ON)/i, tags);
                return match[1] === 'Now ON';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`k${this.deviceId}sA00${power ? '1' : '0'}`, /(Power On|Power Down|MStar STR Suspending)/i, tags, { sendTimeoutMs: power ? 5000 : 25000 });
                if (match[1]) {
                    const powerBusyMs = 20000;
                    this.state.busy.update(true);
                    this.busyTimeout.set(() => this.state.busy.update(false), powerBusyMs);
                    this.framework.suspend(powerBusyMs);
                    return power;
                }
                return this.state.power.value;
            }),
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`k${this.deviceId}gh000`, /k\d+rh(\d+)/i, tags);
                return match[1];
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`k${this.deviceId}sB${code}`, /k\d+(y|n)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                return match[1] === 'y' ? code : this.state.videoInput.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`k${this.deviceId}gf000`, /k\d+rf(\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`k${this.deviceId}sP${volume.toString().padStart(3, '0')}`, /^k\d+(y|n)/i, tags);
                return match[1] === 'y' ? volume : this.state.volume.value;
            }),
            range: { max: 100, min: 0, round: 1 },
            powerOffRestrictions: ['get', 'set'],
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`k${this.deviceId}gg000`, /k\d+rg00(\d)/i, tags);
                return match[1] === '1';
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`k${this.deviceId}sQ00${mute ? '1' : '0'}`, /k\d+(y|n)/i, tags);
                return match[1] === 'y' ? mute : this.state.volumeMute.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            { intervalMs: 3000, controls: ['power', 'videoInput'] },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
LiteTouch.driverType = 'socketDriver';
LiteTouch.key = '-Mj5HiqN-qv3fVyBhWGK';
LiteTouch.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
};
LiteTouch.socketOptions = [
    Object.assign(Object.assign({}, LiteTouch.baseSocketOptions), { port: 4999 }),
    Object.assign(Object.assign({}, LiteTouch.baseSocketOptions), { port: 23 }),
];
